const READ_WRITE = 1
const READ_ONLY = 2

function getTokenPermission() {
  try {
    const token = localStorage.getItem('a-xny-token')
    const encodedPayload = token && token.split('.')[1]
    if (!encodedPayload) return null
    const base64 = encodedPayload.replace(/-/g, '+').replace(/_/g, '/')
    const padding = '='.repeat((4 - base64.length % 4) % 4)
    const payload = JSON.parse(window.atob(base64 + padding))
    const principal = payload.sub ? JSON.parse(payload.sub) : null
    return principal ? Number(principal.canEdit) : null
  } catch (error) {
    return null
  }
}

export function getAccountPermission() {
  const storedPermission = localStorage.getItem('a-xny-can-edit')
  const permission = storedPermission === null || storedPermission === ''
    ? getTokenPermission()
    : Number(storedPermission)
  return permission === READ_ONLY ? READ_ONLY : READ_WRITE
}
